export default function parseDate(date) {
  if (!date) return null;
  const parsedDate = new Date(date);

  // Ensure it's always treated in local time
  return new Date(
    parsedDate.getFullYear(),
    parsedDate.getMonth(),
    parsedDate.getDate(), // Only use YMD, discarding the time
    0,
    0,
    0,
    0,
  );
}
